var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _line, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st1 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.5,504.5h312.9c.9,0,1.5-.7,1.5-1.5s0,0,0,0c0,.9-.7,1.5-1.5,1.5H143.5c-.9,0-1.5-.6-1.5-1.5,0,0,0,0,0,0,0,.9.7,1.5,1.5,1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.5,495.1h312.9,0c4.3,0,7.8,3.4,7.8,7.7,0,0,0,0,0,0,0-4.3-3.5-7.8-7.8-7.8H143.5c-4.3,0-7.8,3.4-7.8,7.8s0,0,0,0c0-4.3,3.5-7.7,7.8-7.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.7,511.9c1.2,1.2,2.8,1.9,4.5,1.9h0c-1.7,0-3.3-.7-4.5-1.9h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143.5,504.4h312.9c.9,0,1.5-.6,1.5-1.5,0-.9-.7-1.5-1.5-1.5H143.5c-.9,0-1.5.6-1.5,1.5,0,.9.7,1.5,1.5,1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.8,511.9c1.2,1.2,2.8,1.9,4.5,1.9h327.5c1.7,0,3.3-.7,4.5-1.9l19.1-19.8H112.6l19.1,19.8ZM135.7,502.8c0-4.3,3.4-7.8,7.8-7.8h312.9c4.3,0,7.8,3.4,7.8,7.8s0,0,0,0c0,0,0,0,0,0,0,4.3-3.5,7.8-7.8,7.8H143.5c-4.3,0-7.8-3.4-7.8-7.8s0,0,0,0c0,0,0,0,0,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M496.9,483c1.2-1.8,1.3-3.9.5-5.9l-77.6-180.4h-239.7l-77.6,180.4c-.8,2-.7,4.1.5,5.9,1.2,1.8,3.1,2.8,5.2,2.8h383.5c2.1,0,4-1,5.2-2.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M503.2,474.8l-79.3-184.1V80h-247.9v210.7l-79.3,184.1c-1.7,3.8-1.2,8.2,1,11.7,1.3,2,3.2,3.5,5.2,4.5.1.1.2.3.4.4l23.9,24.8c2.3,2.4,5.6,3.8,8.9,3.8h327.5c3.4,0,6.6-1.4,8.9-3.8l23.9-24.8c.1-.1.2-.3.4-.4,2.1-1,3.9-2.5,5.2-4.5,2.3-3.5,2.7-7.8,1-11.7ZM182.2,86.2h235.4v204.5h-235.4V86.2ZM468.2,511.9c-1.2,1.2-2.8,1.9-4.5,1.9H136.2c-1.7,0-3.3-.7-4.5-1.9h0l-19.1-19.8h374.7l-19.1,19.8ZM108.2,485.8c-2.1,0-4-1-5.2-2.8-1.2-1.8-1.3-3.9-.5-5.9l77.6-180.4h239.7l77.6,180.4c.8,2,.7,4.1-.5,5.9-1.2,1.8-3.1,2.8-5.2,2.8H108.2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 182.2,
    y: 86.2,
    width: 235.4,
    height: 204.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 456.4,
    y1: 495.1,
    x2: 456.4,
    y2: 495.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5,510.7h312.9c4.3,0,7.8-3.4,7.8-7.8s0,0,0,0c0-4.3-3.5-7.7-7.8-7.7H143.5c-4.2,0-7.8,3.4-7.8,7.7,0,0,0,0,0,0,0,4.3,3.4,7.8,7.8,7.8ZM142,502.9c0-.9.7-1.5,1.5-1.5h312.9c.9,0,1.5.6,1.5,1.5,0,0,0,0,0,0,0,.9-.7,1.5-1.5,1.5H143.5c-.9,0-1.5-.7-1.5-1.5s0,0,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHood);
export default __webpack_public_path__ + "static/media/hood.c4377cb119541ab1277bb31ca3fa56d4.svg";
export { ForwardRef as ReactComponent };